import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Modal } from '@vwfs-bronson/bronson-react';
import { RootState } from '../../services/redux';
import { setInfoModalText } from '../../services/redux/features/custom.slice';

export const InfoModal: FunctionComponent = () => {
  const infoModalText = useSelector((state: RootState) => state.custom.infoModalText);
  const { t } = useTranslation();

  const dispatch = useDispatch();

  if (!infoModalText) return null;

  return (
    <Modal
      id="InfoModal"
      buttonCancelText="Fermer"
      onCancel={() => {
        dispatch(setInfoModalText(''));
      }}
      onClose={() => {
        dispatch(setInfoModalText(''));
      }}
      shown
      asPortal
      title={t('app:infoModalTitle')}
      hideTitle
    >
      <Layout center>
        <Layout.Item default="1/1" s="1/1">
          {infoModalText}
        </Layout.Item>
      </Layout>
    </Modal>
  );
};
